import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { giftBatchList, delgiftcode, codeList, deleteGiftCode, exportGiftBatchList } from "@/api/gmtool/packageCode";
import addCode from "./components/addCode.vue";
import articles from "./components/articles.vue";
import other from "./components/other.vue";
import modifyCode from "./components/modifyCode.vue";
import userInfoDetail from "./components/userInfoDetail.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "parcelLot",
  components: {
    addCode: addCode,
    articles: articles,
    other: other,
    modifyCode: modifyCode,
    userInfoDetail: userInfoDetail
  },
  mixins: [gmTool],
  data: function data() {
    return {
      isPrize: false,
      prizeList: [],
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      paramsData: {
        page: 1
      },
      currentPage: 1,
      pageSize: 10,
      isCode: false,
      codeLists: [],
      tableCopyTableList: [],
      exportLoading: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    Renewal: function Renewal() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.getList(1);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    getList: function getList(e) {
      var _this3 = this;

      this.reqLoading = true;
      this.paramsData.page = e;
      giftBatchList(this.paramsData).then(function (res) {
        // this.tableCopyTableList = res.data.query_list;
        // this.list = this.currentChangePage(this.pageSize, this.currentPage)
        // this.total = res.data.total;
        if (res.status == 200) {
          if (!res.data.query_list.length && _this3.paramsData.page > 1) {
            _this3.getList(_this3.paramsData.page - 1);
          } else {
            _this3.list = res.data.query_list;
            _this3.total = res.data.total_num;
          }
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    viewCloose: function viewCloose(data) {
      this.isPrize = true;
      this.prizeList = JSON.parse(data);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('giftCodeBody'),
        prop: 'code_body'
      }, {
        label: this.$t('operationId'),
        prop: 'gen_id'
      }, {
        label: this.$t('claimedCount'),
        prop: 'draw_nums'
      }, {
        label: this.$t('serverIdRoleName'),
        prop: 'usage_users'
      }];
      var data = this.codeLists.map(function (item) {
        var usageUsersText = '/'; // 如果存在 usage_info 且有数据

        if (Array.isArray(item.usage_info) && item.usage_info.length > 0) {
          usageUsersText = item.usage_info.map(function (info) {
            var serverId = info.server_id || '';
            var roleName = info.role_name || '';

            if (serverId || roleName) {
              return "".concat(serverId, "-").concat(roleName);
            }

            return '';
          }).filter(Boolean).join('、'); // 多条记录用顿号分割（如果想在 Excel 中换行展示，也可以用 '\n'）
        }

        return {
          code_body: item.code_body,
          gen_id: item.gen_id,
          draw_nums: item.draw_nums,
          usage_users: usageUsersText
        };
      }); //let data = this.codeLists

      this.$export.csv({
        columns: columns,
        data: data
      });
    },
    exportListdata: function exportListdata() {
      var _this4 = this;

      this.exportLoading = true;
      exportGiftBatchList({
        is_prod: this.paramsData.is_prod
      }).then(function (res) {
        if (res.status == 200) {
          var rawData = res.data.query_list;
          var columns = [{
            label: _this4.$t('type'),
            prop: 'code_type'
          }, {
            label: _this4.$t('quantity'),
            prop: 'gen_num'
          }, {
            label: _this4.$t('claimableCount'),
            prop: 'reward_num'
          }, {
            label: _this4.$t('isSpecialGiftPack'),
            prop: 'is_special_text'
          }, {
            label: _this4.$t('generateTime'),
            prop: 'gen_time'
          }, {
            label: _this4.$t('startTime'),
            prop: 'reg_begintime'
          }, {
            label: _this4.$t('endTime'),
            prop: 'reg_endtime'
          }, {
            label: _this4.$t('expireTime'),
            prop: 'dead_times'
          }, {
            label: _this4.$t('prizeDetails'),
            prop: 'reward_str_text'
          }];
          var data = rawData.map(function (item) {
            // 解析 extra_param（兼容 "[]"、"{}" 及非标准 JSON 格式）
            var extraParam = {};

            try {
              if (item.extra_param && item.extra_param !== '{}' && item.extra_param !== '[]') {
                extraParam = JSON.parse(item.extra_param);
              }
            } catch (e) {
              extraParam = {};
            } // 解析并格式化奖品详情（多条奖品用换行符 \n 连接）


            var rewardText = '/';

            try {
              if (item.reward_str) {
                var rewardList = JSON.parse(item.reward_str);

                if (Array.isArray(rewardList) && rewardList.length > 0) {
                  rewardText = rewardList.map(function (reward) {
                    // 查找 articleList 中匹配的道具对象
                    var matchItem = _this4.articleList.find(function (item) {
                      return item.id == reward.item_id;
                    }); // 如果找到了则取 kind 属性，未找到则降级显示原始 item_id


                    var itemName = matchItem ? matchItem.kind : reward.item_id;
                    var text = "".concat(_this4.$t('nameLabel'), ":").concat(itemName, ", ").concat(_this4.$t('quantity'), ":").concat(reward.num);

                    if (reward.expire) {
                      text += ", ".concat(_this4.$t('time'), ":").concat(reward.expire);
                    }

                    return text;
                  }).join('、');
                }
              }
            } catch (e) {
              rewardText = '/';
            }

            return {
              code_type: item.code_type,
              gen_num: item.gen_num,
              reward_num: item.reward_num,
              is_special_text: item.is_special == 0 ? _this4.$t('no') : _this4.$t('yes'),
              gen_time: item.gen_time || '/',
              reg_begintime: extraParam.reg_begintime || '/',
              reg_endtime: extraParam.reg_endtime || '/',
              dead_times: item.dead_times || '/',
              reward_str_text: rewardText
            };
          }); // 3. 调用导出插件导出 Excel

          _this4.$export.excel({
            columns: columns,
            data: data,
            title: _this4.$route.meta.title || _this4.$t('giftBatchList')
          });
        }
      }).finally(function () {
        _this4.exportLoading = false;
      });
    },
    viewCode: function viewCode(data) {
      var _this5 = this;

      codeList(_objectSpread({
        is_special: data.is_special,
        code_type: data.code_type
      }, this.paramsData)).then(function (res) {
        _this5.codeLists = res.data.query_list;
        _this5.isCode = true;
      });
    },
    // 删除配置
    handleDelete: function handleDelete(data) {
      var _this6 = this;

      this.$confirm(this.$t('confirmDeleteGiftCode'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                deleteGiftCode(_objectSpread({
                  id: data.gen_id
                }, _this6.paramsData)).then(function (res) {
                  _this6.$message({
                    type: "success",
                    message: _this6.$t('deleteSuccess')
                  });

                  setTimeout(function () {
                    _this6.getList();
                  }, 500);
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};